import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStylusComponent } from './simple-icons-stylus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStylusComponent ],
    exports:      [ SimpleIconsStylusComponent ],
    bootstrap:    []
})
export class SimpleIconsStylusModule {}
